module.exports = __webpack_public_path__ + "img/Hebei-speed.ed2d5a13.png";